/**
 * Created by lihanying on 2017/6/30.
 */
import React from 'react'
import { Table, Input, DatePicker, message, Select, Button, Spin } from 'antd'
import {
  clickDownload,
  startTime,
  endTime,
  round,
  copyToClip,
} from '../../../util/index'
import moment from 'moment'
import { changeStringTime, changeToDecimal } from '../../../util'
const { RangePicker } = DatePicker
const Option = Select.Option

export default class extends React.Component {
  state = {
    start_time: moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
    end_time: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    commodity_id: '',
    record_type: '0',
    loading: false,
  }

  componentDidMount() {
    const { start_time, end_time } = this.state
    const data = {
      start_time: start_time,
      end_time: end_time,
      commodity_type: '',
    }
    this.props.fetchClubStorage('ProcurementAll', data).then((res) => {
      this.setState({ loading: false })
    }) //默认值
  }

  onChange = (value, dateString) => {
    this.setState({
      start_time: dateString[0],
      end_time: dateString[1],
    })
  }

  onSubmit = () => {
    const { record_type, start_time, end_time } = this.state
    let a
    if (record_type.length > 0) {
      let data = {
        start_time: moment(start_time)
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss'),
        end_time: moment(end_time).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        commodity_type: this.state.commodity_id,
      }
      if (record_type === '1') {
        a = 'ProcurementRecords' //普通商品
      } else if (record_type === '2') {
        a = 'ProcurementRecordsNO' //非普通商品
      } else {
        a = 'ProcurementAll' //所有商品
      }
      this.setState({ loading: true })
      this.props.fetchClubStorage(a, data).then((res) => {
        this.setState({ loading: false })
      })
    } else {
      message.info('请选择一个商品分组')
    }
  }

  //求和(金额)
  priceSum = (list) => {
    let sum = 0
    list.map((item) => {
      sum += +(+item.qty_income * +item.cost_incomes)
    })
    return sum.toFixed(2)
  }

  render() {
    const { list, storageType } = this.props
    const columns = [
      {
        title: '排序',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '商品',
        dataIndex: 'commodity_name',
        key: 'commodity_name',
      },
      {
        title: '时间',
        dataIndex: 'ctime',
        key: 'ctime',
      },
      {
        title: '操作人员',
        dataIndex: 'operating',
        key: 'operating',
      },
      {
        title: '入库数量',
        dataIndex: 'qty_income',
        key: 'qty_income',
        sorter: (a, b) => a.qty_income - b.qty_income,
      },
      {
        title: '成本价格',
        dataIndex: 'cost_incomes',
        key: 'cost_incomes',
        sorter: (a, b) => a.cost_incomes - b.cost_incomes,
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '成本总价',
        dataIndex: 'sum_price',
        key: 'sum_price',
        sorter: (a, b) => a.sum_price - b.sum_price,
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
    ]

    const data = list.map((item) => {
      item.cost_incomes = round(+item.cost_income / 100, 2)
      item.sum_price = round((+item.cost_income / 100) * item.qty_income, 2)

      return item
    })

    const { start_time, end_time } = this.state
    let reportName = sessionStorage.getItem('reportName')
    if (start_time.length !== 0 && end_time.length !== 0) {
      reportName += `-明细${changeStringTime(start_time)}-${changeStringTime(
        end_time
      )}`
    }
    const sum = this.priceSum(data)

    return (
      <div>
        <div style={{ marginBottom: '1rem' }}>
          <h3>入库明细</h3>
          <span style={{ marginRight: '.5rem' }}>分组</span>
          <Select
            defaultValue="0"
            style={{ width: 200 }}
            placeholder="选择商品分组"
            onChange={(value) => this.setState({ record_type: value })}
          >
            <Option value="0">全部</Option>
            <Option value="1">普通商品</Option>
            <Option value="2">非普通商品</Option>
          </Select>
          <span style={{ margin: ' 0 .5rem 0 1rem' }}>分类</span>
          <Select
            defaultValue=""
            style={{ width: 200 }}
            placeholder="选择商品,可以不选择"
            onChange={(value) => this.setState({ commodity_id: value })}
          >
            <Option value="">全部</Option>
            {storageType &&
              storageType.map((item, idx) => {
                return (
                  <Option value={item.id} key={idx}>
                    {item.name}
                  </Option>
                )
              })}
          </Select>
          <span style={{ margin: ' 0 .5rem 0 1rem' }}>时间</span>
          <RangePicker
            showTime={false}
            defaultValue={[
              moment(this.state.start_time),
              moment(this.state.end_time),
            ]}
            format="YYYY-MM-DD"
            placeholder={['开始时间', '结束时间']}
            onChange={this.onChange}
            style={{ display: 'inlineBlock' }}
          />
          <Button
            type="primary"
            style={{ marginLeft: '1rem' }}
            onClick={() => this.onSubmit()}
          >
            查询
          </Button>
          <Button
            type="default"
            style={{ marginLeft: '1rem', backgroundColor: '#1AAD19' }}
          >
            <a
              id="test"
              href={clickDownload(columns, data)}
              download={`${reportName}.csv`}
              style={{ color: 'white' }}
            >
              导出
            </a>
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: '1rem' }}
            ghost
            onClick={() => copyToClip(sum)}
          >
            入库总金额:￥{sum}元
          </Button>
        </div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Table
            rowKey="id"
            bordered
            columns={columns}
            dataSource={data}
            size="middle"
            pagination={{ pageSize: 5 }}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubStorage/component/storage.js